import { addBreadcrumb } from "@sentry/react";

/**
 * Add custom breadcrumbs for better debugging context in Sentry
 */

export function addUserActionBreadcrumb(action: string, data?: Record<string, unknown>) {
    addBreadcrumb({
        message: action,
        category: "user.action",
        level: "info",
        data,
        timestamp: Date.now() / 1000,
    });
}

export function addNavigationBreadcrumb(from: string, to: string) {
    addBreadcrumb({
        message: `Navigation: ${from} → ${to}`,
        category: "navigation",
        level: "info",
        data: { from, to },
        timestamp: Date.now() / 1000,
    });
}

export function addAPICallBreadcrumb(endpoint: string, method: string, status?: number) {
    addBreadcrumb({
        message: `API ${method} ${endpoint}`,
        category: "http",
        level: status && status >= 400 ? "error" : "info",
        data: { endpoint, method, status },
        timestamp: Date.now() / 1000,
    });
}

export function addDrawingActionBreadcrumb(action: string, data?: Record<string, unknown>) {
    addBreadcrumb({
        message: `Drawing: ${action}`,
        category: "drawing",
        level: "info",
        data,
        timestamp: Date.now() / 1000,
    });
}

export function addStoryActionBreadcrumb(action: string, storyId?: string, data?: Record<string, unknown>) {
    addBreadcrumb({
        message: `Story: ${action}`,
        category: "story",
        level: "info",
        data: { storyId, ...data },
        timestamp: Date.now() / 1000,
    });
}

export function addAuthActionBreadcrumb(action: string, data?: Record<string, unknown>) {
    addBreadcrumb({
        message: `Auth: ${action}`,
        category: "auth",
        level: "info",
        data,
        timestamp: Date.now() / 1000,
    });
}
